var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 49",
    style: {
      enableBackground: "new 0 0 48 49"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.sv30{enable-background:new    ;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "sv30"
  }, /*#__PURE__*/React.createElement("path", {
    className: "sv31",
    d: "M20.2,48.4c-0.1,0-0.1,0-0.2,0c-0.3-0.1-0.5-0.2-0.6-0.4s-0.2-0.5-0.2-0.7v-18h-18c-0.3,0-0.5-0.1-0.7-0.2 S0.1,28.6,0,28.3c-0.1-0.2-0.1-0.5,0-0.8s0.3-0.4,0.5-0.6L46.2,0.6c0.2-0.1,0.5-0.2,0.8-0.1s0.5,0.1,0.7,0.3 c0.2,0.2,0.3,0.4,0.3,0.7s0,0.5-0.2,0.8L21.4,47.8c-0.1,0.2-0.3,0.3-0.4,0.4s-0.4,0.2-0.6,0.2C20.3,48.4,20.3,48.4,20.2,48.4z  M20.4,26.8c0.3,0,0.6,0.1,0.9,0.4s0.4,0.5,0.4,0.8v14.7L43.5,4.9L5.7,26.8H20.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.8d0c79e3407b59801684156c84f2d8ba.svg";
export { ForwardRef as ReactComponent };